import { map } from 'ramda'
import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React from 'react'

import CheckboxesFilterSideModal from '../../../components/filter/CheckboxesFilterSideModal'
import ProfilesLoader, { useProfiles } from '../_load/ProfilesLoader'

const ProfilesFilterSideModal = ({ label, field, onClose, ...props }) => {
  field = field || 'profileIds'
  label = label || 'Perfil'
  const value = useFilterValue(field, [])
  const handleChange = useChangeFilterValue()
  const { t } = useTranslation()

  return (
    <CheckboxesFilterSideModal
      label={label}
      value={value}
      dataHook={useProfiles}
      mapOptions={map(profile => ({
        label: t('profiles.' + profile.name, profile.name),
        value: profile.id,
        origin: profile
      }))}
      onSubmit={handleChange(field)}
      Loader={ProfilesLoader}
      useSearch
      onClose={v => {
        handleChange(field, v)
        onClose()
      }}
      {...props}
    />
  )
}

export default ProfilesFilterSideModal
